import React, { createContext, useContext, useState, ReactNode } from "react"

interface AnnouncementBannerContextType {
  isVisible: boolean
  setIsVisible: (visible: boolean) => void
  bannerHeight: number
}

const AnnouncementBannerContext = createContext<
  AnnouncementBannerContextType | undefined
>(undefined)

export function AnnouncementBannerProvider({
  children,
}: {
  children: ReactNode
}) {
  const [isVisible, setIsVisible] = useState(true)
  // Banner height: py-3 (0.75rem * 2 = 1.5rem = 24px) + content (~24px) = ~48px on mobile, ~56px on desktop
  const bannerHeight = 48

  return (
    <AnnouncementBannerContext.Provider
      value={{ isVisible, setIsVisible, bannerHeight }}
    >
      {children}
    </AnnouncementBannerContext.Provider>
  )
}

export function useAnnouncementBanner() {
  const context = useContext(AnnouncementBannerContext)
  if (context === undefined) {
    throw new Error(
      "useAnnouncementBanner must be used within AnnouncementBannerProvider"
    )
  }
  return context
}
